import styled from "styled-components";

const Card=styled.div`

background:#20263A;
color:#F8FAFC;
padding:22px;
border-radius:22px;

`;

export default function StudyPlanCard({

plan

}){

return(

<Card>

<h2
style={{
margin:0,
color:"#F8FAFC"
}}
>

📅 Plan de hoy

</h2>

{

plan.map((item,index)=>(

<div
key={index}
style={{
marginTop:18
}}
>

<strong
style={{
color:"#F8FAFC"
}}
>

{item.titulo}

</strong>

<div
style={{
marginTop:6,
color:"#94A3B8"
}}
>

⏱ {item.tiempo} minutos

</div>

{

item.preguntas&&(

<div
style={{
color:"#6EE7B7"
}}
>

📝 {item.preguntas} preguntas

</div>

)

}

</div>

))

}

</Card>

);

}